module.exports = __webpack_public_path__ + "img/Screen2.0a23e0fe.png";